@if (patient) {
  <app-bundle-form
    action="{{ 'new' | translate }}"
    [patient]="patient"
    [mwlItemId]="mwlItemId">
  </app-bundle-form>
}
